import React, { FC } from 'react'
import { buildURL } from 'react-imgix'

import styles from './styles.module.css'

interface ImageProps {
  imageUrl: string
}

const Image: FC<ImageProps> = ({ imageUrl }) => {
  const backgroundImage = buildURL(imageUrl, { auto: 'compress, format' })

  return <div className={styles.image} style={{ backgroundImage: `url(${backgroundImage})` }} />
}

export default Image
